import axios from 'axios'

window.sequenceStepsComponent = ({t_id, root_route, weekdayList}) => ({
    items: [],
    mailTemplates: [],
    t_id: t_id,
    root_route: root_route,
    weekdayList: weekdayList,
    async init() {
        await Promise.all([
            this.fetchSteps(),
            this.fetchMailTemplates(),
        ])
    },
    async fetchSteps() {
        try {
            const {data} = await axios.get(route(this.root_route + '.sequences.sequence_steps.index', {'sequence': this.t_id}))
            this.items = data.data
        } catch (e) {
            httpExceptionHandler(e)
        }
    },
    async fetchMailTemplates() {
        try {
            const {data} = await axios.get(route(this.root_route + '.mail_templates.api-index'))
            this.mailTemplates = data.data
        } catch (e) {
            httpExceptionHandler(e)
        }
    },
})

window.sequenceStepRow = (item = {}) => ({
    item: item,
    oldItem: null,
    errors: {},
    isValid() {
        return this.item.name
            && this.item.mail_template_id
            && (this.item.delay_days > 0 || this.item.delay_days === 0)
    },
    edit() {
        this.oldItem = Object.assign({}, this.item)

        this.item.is_editing = true
    },
    cancel() {
        this.item = Object.assign({}, this.oldItem)

        this.item.is_editing = false
    },
    async create() {
        if (!this.isValid(this.item)) {
            return false;
        }

        try {
            this.errors = {}

            const {data} = await axios.post(route(this.root_route + '.sequences.sequence_steps.create', {'sequence': this.t_id}),
                this.item
            )

            this.item = {}
            toastr.success(data.message)

            await this.fetchSteps()

        } catch (e) {
            httpExceptionHandler(e)
            this.errors = getValidationErrors(e)
        }
    },
    async store() {
        if (!this.isValid(this.item)) {
            return false;
        }

        try {
            this.errors = {}

            const {data} = await axios.post(route(this.root_route + '.sequences.sequence_steps.update', {
                'sequence': this.t_id,
                'sequence_step': this.item.id
            }), this.item)

            this.item.is_editing = false

            toastr.success(data.message)

            await this.fetchSteps()

        } catch (e) {
            httpExceptionHandler(e)
            this.errors = getValidationErrors(e)
        }
    },
    async destroy() {
        if (this.item.is_deleted) {
            return;
        }

        if (!confirm($t('messages.confirm.delete'))) {
            return;
        }

        try {
            const {data} = await axios.delete(route(this.root_route + '.sequences.sequence_steps.delete', {
                'sequence': this.t_id,
                'sequence_step': this.item.id
            }))

            toastr.success(data.message)
            this.item = {is_deleted: true}

            await this.fetchSteps()

        } catch (e) {
            httpExceptionHandler(e)
        }
    },
})
